module.exports = __webpack_public_path__ + "static/media/fct.f0ddfdbb.svg";